import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { BcModel } from 'src/app/shared/models/societe-linked/bc/bc.model';
import { PdfService } from 'src/app/shared/services/pdf.service';


@Component({
  selector: 'app-pdf-bc',
  templateUrl: './pdf-bc.component.html',
  styleUrls: ['./pdf-bc.component.scss'],
})
export class PdfBcComponent implements OnInit, OnChanges {

  @Input() bc: BcModel;
  @Input() memorize: void;
  enabled = false;

  constructor(
    private pdfService: PdfService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.bc && this.bc.idSociete && this.bc.codeSite && this.bc.codeSiteLivraison && this.bc.codeFourn) {
        this.enabled = true;
    }
  }

  print(){
    this.pdfService.print(this.bc);
  }

}
